import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import ListLayout from '../../Generic/ListLayout';
import DataTable from '../../Generic/DataTable';
import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../hooks/useDeleteItem';
import useFilterData from '../../../hooks/useFilterData';
import useFetchData from '../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../hooks/useSetMenu";
import { createLanguageColumn, createGeneralColumn,createActiveColumn, createActionColumn } from '../../Generic/dataGridColumns';
import AuthContext from "../../../context/AuthProvider";
const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useContext(AuthContext);
  const { mainStore, userStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.UserMenuType, mainStore.UserMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  //FetchData and Search


  useFetchData(axiosPrivate, `/Users`, userStore);
  const filteredData = useFilterData(toJS(userStore.user), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  //Delete
  const deleteUser = useDeleteItem(axiosPrivate, '/Users', userStore.deleteUser);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteUser, id);
  }, [deleteUser, t]);

  const cols = useMemo(() => [
	createGeneralColumn("username", "userUsername", t),
    createGeneralColumn("email", "userEmail", t),
    createGeneralColumn("role", "userRole", t),
    createActiveColumn(t),
	createActionColumn(t,"/User/Edit",remove)
    // eslint-disable-next-line
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("userListTitle")}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/User/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);

// import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
// import AuthContext from "../../../context/AuthProvider";
// import { toJS } from 'mobx';
// import { observer } from 'mobx-react-lite';
// import { useTranslation } from 'react-i18next';
// import { useStore } from '../../../stores/store';
// import ListLayout from '../../Generic/ListLayout';
// import DataTable from '../../Generic/DataTable';
// import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
// import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
// import useDeleteItem from '../../../hooks/useDeleteItem';
// import useFilterData from '../../../hooks/useFilterData';
// import useFetchData from '../../../hooks/useFetchData';
// import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
// import { useSetMenu } from "../../../hooks/useSetMenu";
// import { createActiveColumn, createActionColumn, usersCreateActionColumn, usersCreateDataAccessColumn } from '../../Generic/dataGridColumns';
// import { createGeneralColumn } from '../../Generic/dataGridColumns';
// import { Link } from 'react-router-dom';
// const List = () => {
//   const axiosPrivate = useAxiosPrivate();
//   const { mainStore, userStore } = useStore();
//   const { t } = useTranslation();
//   const localizedTextsMap = useLocalizedTextsMap();
//   const { auth } = useContext(AuthContext);
//   const [columns, setColumns] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   useSetMenu(mainStore.UserMenuType, mainStore.UserMenuNo);

//   //FetchData and Search
//   useFetchData(axiosPrivate, "/Users", userStore);
//   const filteredData = useFilterData(toJS(userStore.user), searchQuery);

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   //Delete
//   const deleteUser = useDeleteItem(axiosPrivate, '/Users', userStore.deleteUser);

//   const remove = useCallback((id) => {
//     confirmDeleteDialog(t, deleteUser, id);
//   }, [deleteUser, t]);

//   const cols = useMemo(() => [
//     // createGeneralColumn("fullName", "userFullName", t),
//     createGeneralColumn("username", "userUsername", t),
//     createGeneralColumn("email", "userEmail", t),
//     createGeneralColumn("role", "userRole", t),
//     createActiveColumn(t),
//     (auth?.components?.includes("/User/Edit/:id") || auth?.components?.includes("/User/Delete")) &&
//     (usersCreateActionColumn(t,
//       (auth?.components?.includes("/User/Edit/:id") ? "/User/Edit" : null),
//       (auth?.components?.includes("/User/Delete") ? remove : null))
//     ),
//     // eslint-disable-next-line
//   ], [t, remove]);

//   useEffect(() => {
//     setColumns(cols);
//     // eslint-disable-next-line
//   }, [t]);

//   return (
//     <ListLayout
//       title={t("userListTitle")}
//       searchQuery={searchQuery}
//       onSearchChange={handleSearchChange}
//       searchPlaceholder={t("searchPlaceholder")}
//       addButtonLink="/User/Add"
//       addButtonTitle={t("add")}
//     >
//       <DataTable
//         rows={filteredData}
//         columns={columns}
//         pageSize={pageSize}
//         setPageSize={setPageSize}
//         localeTextsMap={localizedTextsMap}
//       />
//     </ListLayout>
//   );
// };

// export default observer(List);